import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DragLayer } from 'react-dnd'
import { BOARD_DRAG_TYPES_CARD } from '../../../constants/boardDragTypes'
import Card from './Card'
import { CARDTYPE_PREVIEW } from '../../../constants/cardConstants'

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
}

function getItemStyles(props) {
  const { currentOffset } = props
  if (!currentOffset) {
    return {
      display: 'none'
    }
  }

  const { x, y } = currentOffset
  const transform = `translate3d(${x}px, ${y}px, 0)`
  return {
    transform,
    WebkitTransform: transform
  }
}

class CustomDragLayer extends Component {
  static propTypes = {
    item: PropTypes.object,
    itemType: PropTypes.string,
    currentOffset: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired
    }),
    isDragging: PropTypes.bool.isRequired
  }

  renderItem(type, item) {
    switch (type) {
      case BOARD_DRAG_TYPES_CARD:
        return (<Card task={item.task} cardType={CARDTYPE_PREVIEW} />)
      default:
        return null
    }
  }

  render() {
    const { item, itemType, isDragging } = this.props

    if (!isDragging) {
      return null
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)}>
          {this.renderItem(itemType, item)}
        </div>
      </div>
    )
  }
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  }
}


export default DragLayer(collect)(CustomDragLayer)



// WEBPACK FOOTER //
// ./src/routes/Board/components/CustomDragLayer.js